module.exports = __webpack_public_path__ + "img/chevron-back-outline.846b5aba.png";